export const isProductPage = () => location.href.includes('product')
